// @flow
import styled from "styled-components";

export const InlineMessageButtons = styled.div`
  display: flex;
  margin-top: 16px;

  & > a {
    flex: 1;

    &:first-of-type:not(:only-of-type) {
      margin-right: 12px;
    }
  }
`;
